import { render, staticRenderFns } from "./MembershipCard.vue?vue&type=template&id=6b56e8ba&scoped=true&"
import script from "./MembershipCard.vue?vue&type=script&lang=js&"
export * from "./MembershipCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b56e8ba",
  null
  
)

export default component.exports